<div class='editor-container'>
	<quill-editor class='editor' name='editor' [scrollingContainer]="scrollingContainer"
				  [sanitize]='true'
				  [modules]='modules'
				  (onContentChanged)='changedEditor($event)'
				  [(ngModel)]='text' [placeholder]="placeholder"></quill-editor>
</div>
